<template>
  <div>
    <p class="text-2xl mb-6">Statistiques des tables</p>
    <v-col cols="12" class="d-flex flex-row-reverse"> </v-col>
    <v-col cols="12"> <tables-stats-table></tables-stats-table> </v-col>
    <v-col cols="12" class="mt-4">
      <tables-stats-graphs-card></tables-stats-graphs-card>
    </v-col>
  </div>
</template>

<script>
import { mdiPlusBox } from "@mdi/js";
import TablesStatsTable from "@/components/rmr-analytics/tables-stats/tables/TablesStatsTable.vue";
import TableStats from "@/components/c2c/dashboard/cards/TableStatsCard.vue";
import TablesStatsGraphsCard from "@/components/rmr-analytics/cards/TablesStatsGraphsCard.vue";

export default {
  name: "ProjectsList",
  components: {
    TableStats,
    TablesStatsTable,
    TablesStatsGraphsCard,
  },
  created() {},
  data() {
    return {
      icons: {
        mdiPlusBox,
      },
    };
  },
  methods: {},
  watch: {},
};
</script>
<style scoped></style>
